import React from 'react';
import Link from 'react-router/lib/Link';

import { get } from 'Language';

const FooterTools = (params) => (
    <div className="container">
        <div className="row">
            <div className="col-md-3 btn-xs-12" style={{marginTop: 10}}>
                <Link to="/fitters-locator" className="btn btn-block btn-lg btn-success">
                    <i className="fa fa-map-marker"></i> { get('FIND_A_WB_PROF') }
                </Link>
            </div>
            <div className="col-md-3 btn-xs-12" style={{marginTop: 10}}>
                <a href="https://squareup.com/store/wright-balance-fitters" target="_blank" rel="noopener noreferrer"
                   className="btn btn-block btn-lg btn-success"><i className="fa fa-cubes"></i> { get('PRODUCTS') }
                </a>
            </div>
            <div className="col-md-4 btn-xs-12" style={{marginTop: 10}}>
                <a href="" className="btn btn-block btn-lg btn-success">
                    <i className="fa fa-flag"></i>{' '}
                   { get('BECOME_A_WB_FITTER') }?
                </a>
            </div>
            <div className="col-md-2 btn-xs-12" style={{marginTop: 10}}>
                <a href="" className="btn btn-block btn-lg btn-success">
                    <i className="fa fa-book"></i>{' '} 
                   { get('E_BOOKS') }
                </a>
            </div>
        </div>
    </div>
)

export default FooterTools;


// WEBPACK FOOTER //
// ./src/partials/FooterTools.js